
































import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import { Form as ElForm } from 'element-ui'
import { InitModule } from '@/store/modules/init'
import { list, roleAdd, roleUpdate, roleDetails } from '@/api/role'
import { ListResponse, DetailsResponse } from '../index.d'

@Component({
  name: 'RoleOperationModal'
})
export default class extends Vue {
  @Prop({ default: false }) operationDialogFlag!: boolean
  @Prop() id!: number
  private visible = false
  private formParams = {
    name: '',
    remark: '',
    standardType: 1,
    appId: '',
    roleGroupId: ''
  }

  private groupList: ListResponse[] = []

  get appList() {
    return InitModule.appList
  }

  private rules = {
    name: [{ required: true, message: '请输入角色名', trigger: 'change' }],
    standardType: [{ required: true, message: '请选择', trigger: 'change' }],
    appId: [{ required: true, message: '请选择平台', trigger: 'change' }],
    roleGroupId: [{ required: true, message: '请选择角色组', trigger: 'change' }]
  }

  // 选择平台查询角色组
  private async change() {
    const { content } = await list<ListResponse[]>({ appId: this.formParams.appId })
    this.groupList = content
    if (this.groupList.length === 0) {
      this.formParams.roleGroupId = ''
    }
  }

  private close() {
    this.$emit('update:operationDialogFlag', false);
    (this.$refs.form as ElForm).resetFields()
  }

  private onSubmit() {
    (this.$refs.form as ElForm).validate(async(valid: boolean) => {
      if (valid) {
        this.id ? await roleUpdate({ ...this.formParams, id: this.id }) : await roleAdd(this.formParams)
        this.id ? this.$message.success('修改成功') : this.$message.success('新增成功')
        this.$emit('onsubmit')
        this.close()
      }
    })
  }

  @Watch('operationDialogFlag')
  async handQualityDialogFlag() {
    this.visible = this.operationDialogFlag
    if (this.visible && this.id) {
      // 数据回填
      const { content } = await roleDetails<DetailsResponse>({ id: this.id })
      const { name, roleGroupId, remark, appId, standardType } = content
      this.formParams = { name, remark, appId, roleGroupId, standardType }
      await this.change()
    }
  }
}
